import * as React from 'react'
import { FormattedHTMLMessage, defineMessages } from 'react-intl'
import { CheckIcon } from '../../../../components/icon'
import Button from '../../../../components/button'
import FreeHandwriting from '../free-handwriting'
import styles from './subfeatures.module.scss'

const messages = defineMessages({
  arrowText: {
    defaultMessage: "…and it's gratis",
    id: 'free.subfeatures.arrowText',
  },
  feature1Title: {
    defaultMessage: 'Egen logotyp',
    id: 'free.subfeatures.feature1.title',
  },
  feature1Lede: {
    defaultMessage:
      'Med Dooer skräddarsyr du alla dina fakturor som du vill med exempelvis din egen logotyp, fritextfält och mycket mer.',
    id: 'free.subfeatures.feature1.lede',
  },
  feature2Title: {
    defaultMessage: 'Flera olika valutor',
    id: 'free.subfeatures.feature2.title',
  },
  feature2Lede: {
    defaultMessage:
      'Vill du så anpassar du din faktura snabbt och enkelt, med olika valutor och språk, till det som passar just din kund.',
    id: 'free.subfeatures.feature2.lede',
  },
  feature3Title: {
    defaultMessage: 'Automatiska påminnelser',
    id: 'free.subfeatures.feature3.title',
  },
  feature3Lede: {
    defaultMessage:
      'Dooer följer upp dina fakturor åt dig när du sätter en automatisk påminnelse för de fakturor som inte blivit betalda.',
    id: 'free.subfeatures.feature3.lede',
  },
  feature4Title: {
    defaultMessage: 'Alla bokföringsrapporter du behöver',
    id: 'free.subfeatures.feature4.title',
  },
  feature4Lede: {
    defaultMessage:
      'Är du bokföringskund hos Dooer sköts bokföringen automatiskt, i annat fall skapas rapporter som du kan ladda ner.',
    id: 'free.subfeatures.feature4.lede',
  },
  feature5Title: {
    defaultMessage: 'ROT och RUT',
    id: 'free.subfeatures.feature5.title',
  },
  feature5Lede: {
    defaultMessage:
      'Fakturera med ROT- och RUT-avdrag och hantera dina ärenden om utbetalning från Skatteverket direkt i Dooer.',
    id: 'free.subfeatures.feature5.lede',
  },
  feature6Title: {
    defaultMessage: 'Momssatser och rabatter',
    id: 'free.subfeatures.feature6.title',
  },
  feature6Lede: {
    defaultMessage:
      'Både fasta och procent-baserade rabatter går att lägga till på din faktura, om du så vill. Vi stödjer även fakturering med olika momssatser.',
    id: 'free.subfeatures.feature6.lede',
  },
})

const features = [
  {
    title: messages.feature1Title,
    text: messages.feature1Lede,
  },
  {
    title: messages.feature2Title,
    text: messages.feature2Lede,
  },
  {
    title: messages.feature3Title,
    text: messages.feature3Lede,
  },
  {
    title: messages.feature4Title,
    text: messages.feature4Lede,
  },
  {
    title: messages.feature5Title,
    text: messages.feature5Lede,
  },
  {
    title: messages.feature6Title,
    text: messages.feature6Lede,
  },
]

interface ISubFeaturesProps {
  handleClickRegister: () => void
}

const SubFeatures = ({ handleClickRegister }: ISubFeaturesProps) => (
  <div className={styles.root}>
    <Button bankId onClick={() => handleClickRegister()} variant="success">
      <FormattedHTMLMessage defaultMessage="Logga in och börja fakturera" id="free.subfeatures.button" />
    </Button>
    <div className={styles.outer}>
      <div className={styles.handwritingWrapper}>
        <FreeHandwriting
          text={<FormattedHTMLMessage defaultMessage="…and it's gratis" id="free-handwriting" tagName="h3" />}
          variant="left"
        />
      </div>
      <div className={styles.inner}>
        {features.map((feature) => (
          <div className={styles.feature} key={feature.title.defaultMessage}>
            <CheckIcon className={styles.icon} theme="success" />
            <FormattedHTMLMessage tagName="h4" {...feature.title} />
            <FormattedHTMLMessage tagName="p" {...feature.text} />
          </div>
        ))}
      </div>
    </div>
  </div>
)

export default SubFeatures
